import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=536ef1c8&scoped=true&"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPage.vue?vue&type=style&index=0&id=536ef1c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ef1c8",
  null
  
)

export default component.exports